<template>
<div class="swiper-container" ref="container">
  <div class="swiper-wrapper">
    <slot></slot>
  </div>
  <div class="swiper-pagination" :class="{'swiper-pagination-1':indexConfig===1}"></div>
</div>
</template>

<script>
import Swiper from './swiper-lib'
export default {
  props: {
    indexConfig: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    const config = [
      {
        pagination: '.swiper-pagination',
        slidesPerView: 'auto',
        autoplayDisableOnInteraction: false,
        // paginationClickable: true,
        loop: true,
        autoplay: 4000
      },
      {
        pagination: '.swiper-pagination',
        slidesPerView: 'auto',
        autoplayDisableOnInteraction: false,
        // paginationClickable: true,
        loop: true,
        // autoplay: 3000,
        spaceBetween: 8
      }
    ]
    this.swiper = new Swiper(this.$refs.container, config[this.indexConfig])
  },
  deactivated() {
    if (this.swiper) {
      this.swiper.stopAutoplay()
    }
  },
  activated() {
    if (this.swiper) {
      this.swiper.update()
      this.swiper.startAutoplay()
    }
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "~common/stylus/variable"
  .swiper-container{
    width 100%
    height 100%
  }
  .swiper-pagination{
    position: absolute
    z-index 999
    right: 0
    left: 0
    bottom: 0
    text-align: center
    font-size: 0
    .swiper-pagination-bullet{
      display: inline-block
      margin: 0 2px!important
      width: size(8)
      height: size(8)
      border-radius: 50%
      background: rgba(255, 255, 255, .6)
    }
    .swiper-pagination-bullet-active{
      border-radius: size(8)
      width size(20)
      background: #fff
    }
    &.swiper-pagination-1{
      bottom: size(0)!important
      .swiper-pagination-bullet{
        background #d8d8d8
        opacity 1
      }
      .swiper-pagination-bullet-active{
        background: $color-theme
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/swiper/swiper.vue